var a = require("isomorphic-fetch"),
    e = {
  Switzerland: 6.62,
  Norway: 5.86,
  Sweden: 5.84,
  "United States": 5.58,
  Canada: 5.08,
  "Euro area": 4.64,
  Denmark: 4.6,
  Israel: 4.58,
  Brazil: 4.55,
  Australia: 4.35,
  Lebanon: 4.31,
  Uruguay: 4.31,
  Singapore: 4.28,
  "New Zealand": 4.19,
  Britain: 4.07,
  "South Korea": 4.02,
  Chile: 3.89,
  "United Arab Emirates": 3.81,
  "Czech Republic": 3.81,
  "Costa Rica": 3.77,
  Colombia: 3.73,
  Thailand: 3.72,
  Japan: 3.6,
  Honduras: 3.49,
  Kuwait: 3.46,
  Pakistan: 3.31,
  Qatar: 3.3,
  Croatia: 3.24,
  Guatemala: 3.23,
  "Saudi Arabia": 3.2,
  Bahrain: 3.18,
  Nicaragua: 3.18,
  "Sri Lanka": 3.18,
  Peru: 3.14,
  China: 3.05,
  Hungary: 3.03,
  Vietnam: 2.8,
  Poland: 2.8,
  Jordan: 2.75,
  Oman: 2.73,
  Philippines: 2.67,
  India: 2.55,
  "Hong Kong": 2.55,
  Mexico: 2.54,
  Indonesia: 2.34,
  Azerbaijan: 2.33,
  Moldova: 2.32,
  Romania: 2.29,
  Taiwan: 2.24,
  "South Africa": 2.24,
  Egypt: 2.23,
  Malaysia: 2.2,
  Argentina: 2,
  Turkey: 2,
  Ukraine: 1.94,
  Russia: 1.65
},
    t = function t(a, e) {
  void 0 === e && (e = !1), this.ipstack_key = a, this.cache = {}, this.enableSSL = e;
};

t.prototype.ipstack = function (e) {
  try {
    var n = function n() {
      return t.cache[r];
    };

    var t = this;

    var r = e || "check",
        i = function () {
      if (!t.cache[r]) return Promise.resolve(a("http" + (t.enableSSL ? "s" : "") + "://api.ipstack.com/" + r + "?access_key=" + t.ipstack_key)).then(function (a) {
        return Promise.resolve(a.json()).then(function (a) {
          t.cache[r] = a;
        });
      });
    }();

    return i && i.then ? i.then(n) : n();
  } catch (a) {
    return Promise.reject(a);
  }
}, t.prototype._price = function (a, t) {
  var n = a / e["United States"],
      r = a;
  return t.country_name in e ? r = Math.round(n * e[t.country_name]) : "EU" === t.continent_code ? r = Math.round(n * e["Euro area"]) : "AS" === t.continent_code ? r = Math.round(n * e.Vietnam) : "AF" === t.continent_code ? r = Math.round(n * e.Egypt) : "SA" === t.continent_code && (r = Math.round(n * e.Brazil)), r;
}, t.prototype.price = function (a, e) {
  try {
    var t = this;
    return Promise.resolve(t.ipstack(e)).then(function (e) {
      return t._price(a, e);
    });
  } catch (a) {
    return Promise.reject(a);
  }
}, t.prototype.priceWithLocation = function (a, e) {
  try {
    var t = this;
    return Promise.resolve(t.ipstack(e)).then(function (e) {
      return {
        fairPrice: t._price(a, e),
        location: e
      };
    });
  } catch (a) {
    return Promise.reject(a);
  }
}, exports.BigMacIndex = e, exports.ParityPrice = t;